import { ComponentType } from "react";
import { useTranslateClassName } from "../../../hooks/useTranslateClassName";

const withTranslateClassName = (WrappedComponent: ComponentType<any>) => {
  const WithTranslateClassNameComponent = (props: any) => {
    const translateClassName = useTranslateClassName();

    return (
      <WrappedComponent {...props} translateClassName={translateClassName} />
    );
  };

  WithTranslateClassNameComponent.displayName = `withTranslateClassName(${WrappedComponent.displayName || WrappedComponent.name})`;

  return WithTranslateClassNameComponent;
};

export default withTranslateClassName;
